module.exports = __webpack_public_path__ + "img/bridge3.b0613428.png";